export default "__VITE_ASSET__BchIHG63__"